import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Simple in-memory cache for GET requests
const cache = new Map();
const CACHE_DURATION = 30000; // 30 seconds

// Axios instance with credentials
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000, // 30 second timeout
});

// Request interceptor - add auth token from localStorage if cookie not available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - handle errors gracefully
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only clear token on explicit auth endpoint failures (not every 401)
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Only treat /auth/me failure as a session invalidation
      if (url.includes('/auth/me')) {
        localStorage.removeItem('session_token');
      }
    }
    return Promise.reject(error);
  }
);

// Cached GET request helper
export const cachedGet = async (url, options = {}) => {
  const cacheKey = url;
  const cached = cache.get(cacheKey);
  
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return { data: cached.data };
  }
  
  const response = await api.get(url, options);
  cache.set(cacheKey, { data: response.data, timestamp: Date.now() });
  return response;
};

// Clear cache for a specific key or all
export const clearCache = (key = null) => {
  if (key) {
    cache.delete(key);
  } else {
    cache.clear();
  }
};
